import React from "react";
import Modal from "../../../../elements/Modal";
import ManageFinance from "../ManageFinance";

const ManageFinanceModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl4"
      title={data?._id ? "Update One" : "Create New "}
    >
      <ManageFinance getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageFinanceModal;
